module.exports = __webpack_public_path__ + "media/images/s2ep3-cindy-12e7841ab0e71aed550eaa5c307bf261.png";